import { Event } from '../event';

export class SystemEvent extends Event {

}
